import React from "react";

import VerificationIcons from "../TreatmentPage/components/VerificationIcons";

function Vists({ visits, dates, handleShow, verification }) {
  return (
    <button
      type="button"
      onClick={handleShow}
      className="treatment-visit-range d-flex align-items-center margin-left-low cursor-pointer"
    >
      <VerificationIcons
        type="visits"
        verificationData={verification?.verification_info?.visits}
        visits={visits}
      />
      <VerificationIcons
        type="first"
        verificationData={verification?.verification_info?.first_date}
        dates={dates}
      />
      <span className="text-primary-25" style={{ fontWeight: 600 }}>
        to
      </span>
      <VerificationIcons
        type="last"
        verificationData={verification?.verification_info?.second_date}
        dates={dates}
      />
    </button>
  );
}

export default React.memo(Vists);
